import styled, { css, keyframes, createGlobalStyle } from 'styled-components'
import { motion } from 'framer-motion'
import * as colors from '../../styles/abstracts/_variables.styles'
import * as breakpoints from '../../styles/abstracts/_breakpoints'

// Breakpoints
const {
  xxSmallDevices,
  xxSmallDevicesLandscape,
  extraSmallDevices,
  extraSmallDevicesLandscape,
  mediumDevices,
  mediumDevicesLandscape,
  largeDevices,
  extraLargeDevices,
  xxLargeDevices,
} = breakpoints

export const Container = styled(motion.div)`
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  gap: 4rem;
  height: 100%;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
    padding: 10rem 10rem;
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
    padding: 10rem 10rem;
  }
  @media ${xxLargeDevices} {
    padding: 10rem 10rem;
  }
`
